(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["waitlist-modal"] && !Shopify.designMode) return;
  try {
    const modal = document.getElementById('waitlistModal');
  if (modal && document.documentElement.hasAttribute('data-purchase-paused')) {
    const seenKey = 'gr_waitlist_seen';
    const open = (force) => {
      if (!force && sessionStorage.getItem(seenKey) === '1') return;
      modal.hidden = false;
    };
    const close = () => {
      modal.hidden = true;
      sessionStorage.setItem(seenKey, '1');
    };
    const buySelector = '[data-pdp-add], [data-bundle-add], button[name="add"], #pdpAdd, button[name="checkout"]';
    const label = '予約受付中';
    const relabelBuys = () => {
      document.querySelectorAll(buySelector).forEach((btn) => {
        if (btn.id === 'cartCheckout') return;
        if (btn.textContent.trim() !== label) btn.textContent = label;
      });
    };
    const lockCheckout = () => {
      const checkout = document.getElementById('cartCheckout');
      if (!checkout || (checkout.textContent.trim() === label && checkout.disabled)) return;
      checkout.textContent = label;
      checkout.disabled = true;
    };
    relabelBuys();
    lockCheckout();
    const checkout = document.getElementById('cartCheckout');
    if (checkout) {
      new MutationObserver(lockCheckout).observe(checkout, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener('click', () => {
      requestAnimationFrame(() => {
        relabelBuys();
        lockCheckout();
      });
    }, true);
    document.addEventListener('click', (event) => {
      const buy = event.target.closest(buySelector);
      if (buy && buy.id !== 'cartCheckout') {
        event.preventDefault();
        event.stopPropagation();
        open(true);
        return;
      }
      const link = event.target.closest('a[href]');
      if (!link) return;
      let path = '';
      try { path = new URL(link.href, location.origin).pathname; } catch (_) { return; }
      if (path === '/checkout' || path.indexOf('/checkout/') === 0 || path === '/cart' || path.indexOf('/cart/') === 0) {
        event.preventDefault();
        event.stopPropagation();
        open(true);
      }
    }, true);
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || form.id === 'waitlistForm') return;
      const action = form.getAttribute('action') || '';
      if (action.indexOf('/cart') !== -1 || form.querySelector('[name="add"], [name="checkout"]')) {
        event.preventDefault();
        event.stopPropagation();
        open(true);
      }
    }, true);
    modal.querySelector('[data-waitlist-close]')?.addEventListener('click', close);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) close();
    });
    const drawer = document.getElementById('cartDrawer');
    if (drawer) {
      new MutationObserver(() => {
        if (drawer.classList.contains('open')) open(false);
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    if (modal.querySelector('[data-waitlist-success]')) open(true);
    else if (modal.hasAttribute('data-waitlist-auto')) open(false);
  }
  } catch(e) { console.error(e); }
})();

})();
